import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.25 12.002a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0M12 9.752a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.324 11.45C2.81 6.977 7.028 3.751 12 3.751c4.97 0 9.186 3.223 10.675 7.69.12.362.12.753 0 1.114-1.487 4.47-5.704 7.696-10.677 7.696-4.97 0-9.186-3.222-10.675-7.69a1.76 1.76 0 0 1 0-1.113M12 5.251a9.755 9.755 0 0 0-9.254 6.67.26.26 0 0 0 0 .166 9.755 9.755 0 0 0 18.506-.006.26.26 0 0 0 0-.165A9.755 9.755 0 0 0 12 5.252",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }